
export interface RunningBackup {
    startTime: Date;
    isFull: boolean;
    runningBackupTaskId: number;
}
